import { setGlobalTranslations } from "../../../src/app/core/translateServiceModule/TranslationsSelector";
import { executeGet } from "../utils/apiUtils";
import { getCookie } from "../utils/getCookie";

import LogService from "./logService";

const accu = getCookie("accu") || "Empower";

export const getTranslationsService = () => {
    const method = "getTranslations";

    const getTranslationsSuccess = (results) => {
        if (results) {
            setGlobalTranslations(results.data);
            return results.data;
        }
    };

    const getCustomizationPath = (accuCode) => {
        return __styleEnv__ + "customizations/" + accuCode + "/locales/";
    };

    const getUrl = (accuCode) => {
        const cacheBustEveryFifteenMinutes = Math.floor(Date.now() / 900000);
        const url = getCustomizationPath(accuCode) + "en_US.json?v=" + cacheBustEveryFifteenMinutes;

        return url;
    };

    return executeGet(getUrl(accu), "getTranslationsFault")
        .then(getTranslationsSuccess)
        .catch((e) => {
            LogService.getLogger().error(method + "Error - getTranslations failed", e);
        });
};
